export const headers = [
  { field: "id", headerName: "ID", width: 70, hidden: true },
  { field: "tiva_abrev", headerName: "Abrev", width: 70 },
  { field: "tiva_descripcion", headerName: "Descripcion", width: 230 },
  { field: "tiva_afip_codigo", headerName: "Afip-Codigo", width: 70 },
  { field: "tiva_fiscal_codigo", headerName: "Fiscal-Codigo", width: 230 },
  ];
  